import { post, get } from 'Api';
import store from 'Redux/store';

export const REFRESH_AUTH = 'frontend/auth/REFRESH_AUTH';
export const NEW_URL = 'frontend/epic/NEW_URL';

export default async function linkEpic(code, state) {
  const { response, data } = await post(store.dispatch, '/user/link-epic', { code, state });

  if (response.ok) {
    return store.dispatch({ type: REFRESH_AUTH, payload: data });
  }

  if (data.err) {
    throw new Error(data.err);
  }

  throw new Error('Unexpected Error');
}

export async function getUrl() {
  const { response, data } = await get(store.dispatch, '/user/epicurl');

  if (response.ok) {
    return store.dispatch({ type: NEW_URL, payload: data });
  }

  if (data.err) {
    throw new Error(data.err);
  }

  throw new Error('Unexpected Error');
}
